import comp from "./PromptList";
export default comp;
